import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import styles from './TinyOfferCard.module.css';
import { measureTypeForm } from '../../../../../support/services/formatter';

import { Image } from '../../../../components';

const useTinyOfferCard = () => {
  const history = useHistory();

  const handleClick = (nickname) => history.push(`/${nickname}`);

  return {
    eventsHandlers: {
      handleClick,
    },
  };
};

function TinyOfferCard({ offer = {}, nickname }) {
  const {
    name,
    value,
    measureType,
    measureQuantity,
    imagesPaths,
  } = offer;

  const imageUrl = imagesPaths[imagesPaths?.length - 1];
  const { eventsHandlers } = useTinyOfferCard();

  return (
    <button
      type="button"
      className={styles.card}
      onClick={() => eventsHandlers.handleClick(nickname)}
    >
      <div className={styles['offer-image']}>
        <Image src={imageUrl} alt={`Foto do produto ${name}`} />
        <p className={styles['offer-price']}>
          {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)}
        </p>
      </div>

      <section>
        <div className={styles['offer-info']}>
          <h2>{name}</h2>
          <p>{`(${measureQuantity} ${measureTypeForm(measureType, measureQuantity)})`}</p>
        </div>

      </section>
    </button>
  );
}

TinyOfferCard.propTypes = {
  offer: PropTypes.object,
};

export default TinyOfferCard;
